import SectionGroupService from "@source/api/services/sectionGroupService";

export default class SectionGroupController {
  static async getByNursingHome(nursingHomeId: string) {
    return await SectionGroupService.getByNursingHome(nursingHomeId);
  }
}
